import { render, staticRenderFns } from "./FireQuickInfo.vue?vue&type=template&id=14ac93fc&"
import script from "./FireQuickInfo.vue?vue&type=script&lang=js&"
export * from "./FireQuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./FireQuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireQuickInfo.vue"
export default component.exports